export function getFilenameFromContentDispositionHeader(headers) {
  const contentDisposition = headers.get("Content-Disposition");
  if (contentDisposition) {
    const parts = contentDisposition.split(";");
    for (let part of parts) {
      part = part.trim();
      const filenamePrefix = "filename="
      if (part.startsWith(filenamePrefix)) {
        //trim extra quotes if they are present after trimming "filename="
        let filename = part.substring(filenamePrefix.length);
        if (filename.startsWith('"') && filename.endsWith('"')) {
            filename = filename.slice(1, filename.length - 1);
        }

        return filename;
      }
    }
  }
  return undefined;
}
